module.exports = __webpack_public_path__ + "img/RECUADRO_Acompañamiento_XS.8ddeec66.png";